module.exports = __webpack_public_path__ + "img/elenco_smartbook.b6f3965b.png";